import { loadObjectFromServer, getData } from "@/utils";

export async function getZIPMapFeatures(locationId) {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  let location_id = locationId;
  if (!location_id) {
    location_id = window.sessionStorage.getItem("selected_location")
      ? window.sessionStorage.getItem("selected_location")
      : null;
  }
  let url = `${APP_ROUTES.ZIP_MAP_FEATURES}?location_id=${location_id}`;
  return await getData(url);
}

export async function getSpendingMapFeatures(
  type,
  date,
  page = 1,
  pageSize = 50
) {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  let url = `${APP_ROUTES.MAP_FEATURES}?type=${type}&date=${date}&page=${page}&page_size=${pageSize}`;
  return await getData(url);
}

export async function getSpendingMapFeaturesV2(type,date) {
  let url = `/benchmark/generate-aben-overview/?type=${type}&date=${date}`;
  return  await getData(url);
}

export async function getSpendingMinMaxDates() {
  try {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const response = await getData(APP_ROUTES.SPENDING_DATES);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getGeography(isSubscribed) {
try {
    const APP_ROUTES = `/benchmark/aben-overview-geography-list/?is_subscribed=${isSubscribed}`;
    const response = await getData(APP_ROUTES);
    return response;
  } catch (e) {
    return null;
  }
}